import {CustomPermission, ICustomPermission} from './custom-permission.model';

export interface ICustomRole {
    id: number;
    label: string;
    access_level: number;
    permissions: CustomPermission[];
}

export class CustomRole implements ICustomRole {
    public id: number;
    public label: string;
    public access_level: number; // tslint:disable-line: variable-name
    public permissions: CustomPermission[];

    constructor(options: {
        id?: number,
        label?: string,
        access_level?: number,
        permissions?: CustomPermission[],
    } = {}) {
        this.id = options.id || -1;
        this.label = options.label || '';
        this.access_level = options.access_level || -1;
        if (options.permissions && options.permissions.length) {
            this.permissions = options.permissions.map((permission: ICustomPermission) => {
                return new CustomPermission(permission);
            });
        } else {
            this.permissions = [];
        }
    }
}
